var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"app":""}},[_c('v-toolbar-title',{staticClass:"headline text-uppercase"},[_c('span',[_vm._v("SKM Cpanel")])]),_c('v-spacer')],1),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }